<template>
  <div class="PublicTabs" :class="TabStyle==2?`productInfo`:``" ref="PublicTabs">
    <div v-if="TabStyle == 0">
      <!-- 自定义 Tabs 组件 -->
      <div class="custom-tabs">
        <!-- Tab 头部 -->
        <div class="custom-tabs-nav" :class="{ 'has-inline-extra': !!$slots.tabInlineExtra }">
          <div class="custom-tabs-nav-leading">
            <!-- 标签页列表 -->
            <div class="custom-tabs-nav-list">
              <div 
                v-for="(item, index) in TabList" 
                :key="index" 
                v-if="item.IsShow"
                :class="[
                  'custom-tab-nav-item',
                  { 'active': currentTab === index },
                  { 'disabled': item.status === 2 }
                ]"
                @click="ChangeTabs(index)"
                :t_label="item.t_label"
              >
                <span :class="item.status == 1 ? 'd-inline font-danger' : 'font-primary'">
                  {{ item.name }}
                </span>
                 <img style="width: 15px;height: 15px;" v-if="item.status == 1" :src="cdnURL + 'warn.svg'" />
                 <img style="width: 15px;height: 15px;" v-if="item.status == 2" :src="cdnURL + 'lock.svg'" />
              </div>
            </div>
            <div class="custom-tabs-nav-inline-extra" v-if="$slots.tabInlineExtra">
              <slot name="tabInlineExtra"></slot>
            </div>
          </div>
          <!-- 右侧额外内容区域（固定右上角，不受 tab 换行影响） -->
          <div class="custom-tabs-nav-extra" v-if="$slots.tabExtra">
            <slot name="tabExtra"></slot>
          </div>
        </div>
        
        <!-- Tab 内容区域 -->
        <div class="custom-tabs-content">
          <div class="custom-tab-pane-extra" v-if="$slots.tabPaneExtra">
            <slot name="tabPaneExtra"></slot>
          </div>
          <div class="custom-tab-pane">
            <slot v-if="currentTab === 9999 && $slots.tab9999" name="tab9999"></slot>
            <template v-else>
              <!-- 所有标签页内容都预加载，通过v-show控制显示 -->
              <div 
                v-for="(item, index) in TabList" 
                :key="item.name" 
                v-if="item.IsShow"
                v-show="currentTab === index"
                class="tab-content-item"
              >
                <slot :name="'tab' + index"></slot>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
     <div v-else-if="TabStyle == 2">
      <!------新版productInfo------>
      <div class="tab-continer row" >
      <div class="tab-left-tab">
        <div class="leftCard_proInfo" ref="leftCard_proInfo">
        <b-card no-body class="b-r-3 bCardStyle b_Card">
          <b-card-title >
            <slot name="TabCardHead"></slot>

          </b-card-title>
          <b-card-body>
            <div class="CardBody">
              <ul class="ItmeUL">
                <li :id="`tab_${item.ProgressPage}`" style="" v-for="(item, index) in TabList" :name="item.ProgressPage" :key="item.ProgressPage" @click="ChangeTabs(index)" v-if="item.IsShow">
                  <div class="li-Style_proinfo">
                    <div :class="(currentTab == index ? 'li-span_Blue_proinfo' : ' li-span_write_proinfo') + ' li-span_proinfo'">
                      <div :class="(currentTab == index ? 'serialNum_blue_proinfo ' : ' ') + 'serialNum'">{{ index + 1 }}</div>
                      <div :class="(currentTab == index ? 'serialName_blue_proinfo ' : ' ') + 'serialName'">
                        <div class="name">
                          {{ item.name }}
                        </div>
                        <div class="edit" >
                        <img v-if="item.status == 1"  :src="cdnURL+'Error.svg'" style="padding-right: 8px;" />
                        <img :src="cdnURL+'arrowRight.svg'">
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </li>
              </ul>
            </div>
           

          </b-card-body>
        </b-card>
        
        <div no-body class="assitantCard"> 
         <slot name="TabCardFoot"></slot>
        
        </div>
         <div id="updatetime"> <slot name="RightSlot"></slot> </div>
         <div style="height: 60px;width: 100%;"></div>
        </div>
      </div> 
      <div class="tab-center-tab">
        <b-overlay :show="Loading" rounded="sm" :style="Loading ? 'height:800px;overflow:hidden;' : 'padding-bottom:20px;margin-bottom: 20px;'">
          <div v-if="LoadAnimation == 0">
            <slot :name="'tab' + currentTab"></slot>
          </div>
          <div v-else>
            <div v-for="(item, index) in TabList" :key="item.name" ref="AllTabs" v-if="item.IsShow">
              <slot :name="'tab' + index"></slot>
            </div>
          </div>
        </b-overlay>
      </div>
      </div>
    </div>
    <div v-else>
      <!------tab left width 22% ; tab center width 50% ; tab right width 22%  ; 后续该公用组件请通过props 更改布局------>
      <div :class="IsHiddenRight ? 'tab-left-Big' : 'tab-left'">
        <b-card no-body class="b-r-3 bCardStyle">
          <b-card-title>
            <slot name="TabCardHead"></slot>

          </b-card-title>
          <b-card-body>
            <div class="CardBody">
              <ul>
                <li v-for="(item, index) in TabList" :key="item.name" @click="ChangeTabs(index)" v-if="item.IsShow">
                  <div class="li-Style">
                    <div :class="(currentTab == index ? 'li-span_Blue ' : ' li-span_write') + ' li-span'">
                      <div :class="(currentTab == index ? 'serialNum_blue ' : ' ') + 'serialNum'">{{ index + 1 }}</div>
                      <div :class="(currentTab == index ? 'serialName_blue ' : ' ') + 'serialName'">
                        <div class="name">
                          {{ item.name }}
                        </div>
                        <div class="edit">
                          <img :src="cdnURL + (currentTab == index ? 'Edit.svg' : 'Edit_Blue.svg')" />
                        </div>
                      </div>
                    </div>
                    <div class="warn">
                      <img v-if="item.status == 1" :src="cdnURL + 'warn.svg'" />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <slot name="TabCardFoot"></slot>

          </b-card-body>
        </b-card>
        <!-- IsHiddenRight 为 false 时，把 RightSlot 放到左侧卡片底下，并沿用 TabStyle=2 的样式结构 -->
        <template v-if="IsHiddenRight">
          <div id="updatetime">
            <slot name="RightSlot"></slot>
          </div>
          <div style="height: 60px;width: 100%;"></div>
        </template>
      </div>
      <div :class="IsHiddenRight ? 'tab-center-Big' : 'tab-center'">
        <b-overlay :show="Loading" rounded="sm" :style="Loading ? 'height:800px;overflow:hidden;' : ''">
          <div v-if="LoadAnimation == 0">
            <slot :name="'tab' + currentTab"></slot>
          </div>
          <div v-else>
            <div v-for="(item, index) in TabList" :key="item.name" ref="AllTabs" v-if="item.IsShow">
              <slot :name="'tab' + index"></slot>
            </div>
          </div>
        </b-overlay>
      </div>
      <div :class="RightOnleftFooterShow ? 'tab-right-Big' : 'tab-right'" v-if="!IsHiddenRight || RightOnleftFooterShow">
        <slot name="RightSlot"></slot>
      </div>
    </div>
  </div>

</template>

<script>
import { AlertDialog } from "@/_helpers/AlertDialog";
export default {
  mixins: [AlertDialog],
  props: {
    value: {
      type: Number,
      default: 0
    },
    //0 横显示 1 竖显示
    TabStyle: {
      type: Number,
      default: 0
    },
    //加载动画 0 切换 1 滑页
    LoadAnimation:
    {
      type: Number,
      default: 0
    },
    Loading: {
      type: Boolean,
      default: false
    },
    //status 即 0 normal , 1 warn , 2  NoPermission  请遵循这三种规则
    TabList: {
      type: Array,
      default: () => [
        { name: "a", status: 0, t_label: "EMPBE_CompanyInfoCentera", IsShow: true },
        { name: "b", status: 1, t_label: "EMPBE_CompanyInfoCenterb", IsShow: true },
        { name: "c", status: 2, t_label: "EMPBE_CompanyInfoCenterc", IsShow: false },
        { name: "d", status: 1, t_label: "EMPBE_CompanyInfoCenterd", IsShow: true },
        { name: "e", status: 3, t_label: "EMPBE_CompanyInfoCentere", IsShow: true },
      ]
    },
    IsHiddenRight: {
      type: Boolean,
      default: false
    },
    IsSavePrompt:
    {
      type: Boolean,
      default: false
    },
    /** dirty 时切换 tab 直接触发 save，不弹离开确认框 */
    AutoSaveOnTabChange: {
      type: Boolean,
      default: false
    },
    /** 不论 dirty，切 tab 都触发 save（审批驳回草稿等场景） */
    AlwaysAutoSaveOnTabChange: {
      type: Boolean,
      default: false
    },
    RightOnleftFooterShow:
    {
      type: Boolean,
      default: false
    },
    PageLeaveType: {
      type: Number,
      default: 0 // 页面状态
    },
    PageLeaveContent:
    {
      type: Object,
      default:function () {
            return {
              SubmitTitle:this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Title'),
              SubmitText: this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Body'),
              SubmitConfirmBtn: this.$t('lbl_EMPBE_CompanyInfo_Submit'),
              SaveTitle: this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Title'),
              SaveText: this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Body'),
              SaveConfirmBtn: this.$t('lbl_EMPBE_CompanyInfo_Save'),
            }
          }

    },
     IshowlastUpdateDateTab: {
     type: Boolean,
      default: true
    },
  ProgressValue: {
      type: Number,
      default: 0 // 页面状态
    },
  },
  data() {
    return {
      currentTab: this.value,
      cdnURL: "https://cdn.adsalecdn.com/EMP/Backend/svg/PublicTabs/",
      leftColResizeObserver: null,
    }
  },
  watch: {
    value() {
      this.currentTab = this.value
    },
    currentTab() {
      //在切换页时常常有页面高度不匹配情况 所以得滑动到顶部 但是滑页不存在该问题
      if (this.LoadAnimation == 0) {
        const ThenPage = this.$refs.PublicTabs;
        ThenPage.scrollIntoView({ behavior: 'smooth' });
      }
    }
  },
  computed: {
    getIsVerticalShow() {
      return this.LoadAnimation == 1 && this.TabStyle == 1;
    },
    
  },
  mounted() {
    if (this.getIsVerticalShow) {
      window.addEventListener('scroll', this.handleScroll);
    }
    if (this.TabStyle === 2) {
      window.addEventListener('resize', this.resizeleftCardHeight);
      this.bindLeftColResizeObserver();
    }
    this.resizeleftCardHeight();

    this.setDefualtStyle_needTodo();
  },
  beforeDestroy() {
    if (this.getIsVerticalShow) {
      window.removeEventListener('scroll', this.handleScroll);
    }
    if (this.TabStyle === 2) {
      window.removeEventListener('resize', this.resizeleftCardHeight);
    }
    if (this.leftColResizeObserver) {
      this.leftColResizeObserver.disconnect();
      this.leftColResizeObserver = null;
    }
  },
  methods: {
    ChangeTabs(index) {
      // 检查是否禁用
      // if (this.TabList[index].status === 2) {
      //   return;
      // }
      
      this.TipsByTabChange(index).then(res => {
        //  console.log('TipsByTabChange');
        if (res) {
          if (this.getIsVerticalShow) {
            const tab = this.$refs.AllTabs[index];
            // console.log('tab');
            if (tab) {
              tab.scrollIntoView({ behavior: 'smooth' });
            }
          }
          else {
              this.ChangeCurrentTab(index);
          }
        }
      })

    },
    setDefualtStyle_needTodo(){
      var objTip=document.getElementById("needTodo_sub_"+0);     
      if (objTip) { 
        this.ChangeCurrentTab(0); 
      }else{
         setTimeout(() => { 
        this.setDefualtStyle_needTodo(0);
      }, 500);  
      }
    },
    //当tab切换时 需要做好用户未保存的提示
    TipsByTabChange(topage) {
      return new Promise((resolve, reject) => {
        // 审批等场景：切 tab 始终交给父组件 save，再由其切换
        if (this.AutoSaveOnTabChange && this.AlwaysAutoSaveOnTabChange) {
          this.$emit("save", topage);
          return;
        }
        if (this.IsSavePrompt) {
          if (this.$store.state.dirty) {
            // 自动保存草稿后由父组件 Save → PageNext 切换 tab（与确认保存路径一致，不在此 resolve）
            if (this.AutoSaveOnTabChange) {
              this.$emit("save", topage);
              return;
            }
            if (this.PageLeaveType == 0) {
              this.showLeavePage().then((result) => {
                if (!result.isConfirmed) {
                  resolve(false);
                } else {
                  resolve(true);
                }
              });             
              
            } else if (this.PageLeaveType == 1) {
              this.showLeavePageAfterSave(
                  this.PageLeaveContent.SubmitTitle,
                  this.PageLeaveContent.SubmitText,
                  this.PageLeaveContent.SubmitConfirmBtn,
                ).then((result) => {
                if (result.isDenied) {
                  resolve(true);
                } else if (result.isConfirmed) {
                  this.$emit("submit");
                  //resolve(true);
                }
                else {
                  resolve(false);
                }
              });
            } else if (this.PageLeaveType == 2) {
              this.showLeavePageAfterSave(
                  this.PageLeaveContent.SaveTitle,
                  this.PageLeaveContent.SaveText,
                  this.PageLeaveContent.SaveConfirmBtn,
                ).then((result) => {
                if (result.isDenied) {
                  resolve(true);
                } else if (result.isConfirmed) {
                  console.log('topage'+topage)
                  this.$emit("save",topage);
                  //  setTimeout(() => {
                  //    resolve(true);
                  // }, 300);
                }
                else {
                  resolve(false);
                }
              });
            }
          }
          else {
            resolve(true);
          }
        }
        else {
          resolve(true);
        }
      });
    },
    handleScroll() {

      const sections = this.$refs.AllTabs;
      const scrollY = window.scrollY || window.pageYOffset;

      sections.forEach((element, index) => {
        const elementTop = element.offsetTop;
          const elementBottom = elementTop + element.offsetHeight;
  
          if (scrollY >= elementTop && scrollY < elementBottom)
          {
            this.ChangeCurrentTab(index);
          }
        });
    },
    ChangeCurrentTab(index)
    {
      this.currentTab = index;
      this.$emit('input', index); 
    },
    bindLeftColResizeObserver() {
      if (typeof ResizeObserver === 'undefined') return;
      this.$nextTick(() => {
        const colEl = this.$refs.leftCard_proInfo
          ? this.$refs.leftCard_proInfo.closest('.tab-left-tab')
          : null;
        if (!colEl) return;
        this.leftColResizeObserver = new ResizeObserver(() => {
          this.resizeleftCardHeight();
        });
        this.leftColResizeObserver.observe(colEl);
      });
    },
    resizeleftCardHeight() {
      const leftCard_proInfo = this.$refs.leftCard_proInfo;
      if (!leftCard_proInfo) return;
      const colEl = leftCard_proInfo.closest('.tab-left-tab');
      if (!colEl) return;
      const colRect = colEl.getBoundingClientRect();
      if (colRect.width > 0) {
        leftCard_proInfo.style.width = `${colRect.width}px`;
        leftCard_proInfo.style.left = `${colRect.left}px`;
      }
    }
    
  }
}
</script>
<style lang="scss" scoped>

.card .card-body {
  padding: 0px;
  background-color: transparent;
}

// 自定义 Tabs 样式
.custom-tabs {
    display: flex;
    flex-direction: column;
    gap: 8px;
  .custom-tabs-nav {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    padding: 0;
    margin: 0;

    .custom-tabs-nav-leading {
      flex: 1 1 auto;
      min-width: 0;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px;
    }
    
    .custom-tabs-nav-list {
      display: flex;
      flex-wrap: wrap;
      flex: 1 1 auto;
      min-width: 0;
    }
    
    .custom-tabs-nav-extra {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      align-self: flex-start;
      flex: 0 0 auto;
      min-width: fit-content;
      margin-left: auto;
      text-align: right;
    }

    .custom-tabs-nav-inline-extra {
      display: flex;
      align-items: center;
      flex: 0 0 auto;
      min-width: fit-content;
    }

    &.has-inline-extra {
      .custom-tabs-nav-leading {
        flex: 1 1 0;
      }
    }
    
    .custom-tab-nav-item {
      padding: 0.75rem 1.5rem;
      margin: 0;
      border: none;
      border-bottom: 3px solid transparent;
      cursor: pointer;
      transition: all 0.2s ease-in-out;
      background-color: transparent;
      color: #6c757d;
      font-weight: normal;
      text-decoration: none;
      white-space: nowrap;
      
      &:hover {
        color: #495057;
        background-color: rgba(0, 0, 0, 0.02);
      }
      
      &.active {
        color: #dc3545;
        font-weight: 500;
        border-bottom: 3px #7366FF solid;
        background-color: transparent;
        
        &:hover {
          color: #dc3545;
          background-color: transparent;
        }
      }
      
      &.disabled {
        color: #adb5bd;
        opacity: 0.6;
        
        &:hover {
          color: #adb5bd;
          background-color: transparent;
        }
        
        .fa-lock {
          color: #adb5bd;
        }
      }
      
      .fa {
        margin-right: 0.25rem;
        font-size: 0.875rem;
      }
    }
  }
  
  .custom-tabs-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    border: none;
    
    .custom-tab-pane {
      
      .tab-content-item {
        // 保证所有内容都在DOM中，但只显示当前激活的
        &:not([style*="display: none"]) {
          display: block;
        }
      }
    }
  }
}

// 保持原有的危险和主要颜色样式
.font-danger {
  color: #CD1515 !important;
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
  word-wrap: break-word
}

.font-primary {
  color: rgba(0, 0, 0, 0.80) !important; 
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
  word-wrap: break-word
}
 .PublicTabs .card-header
{
  background-color:#fff !important;
}
</style>
<style> 
.productInfo{
    padding-top: 32px;
}

/* 与页头/驳回区 gutter 对齐：flex + gap 精确控制列间距为 24px */
.productInfo .tab-continer.row {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  margin-left: 0;
  margin-right: 0;
  gap: 24px;
}

.productInfo .tab-continer.row > .tab-left-tab {
  flex: 0 0 calc((100% - 24px) / 3);
  max-width: calc((100% - 24px) / 3);
  min-width: 0;
  padding: 0;
}

.productInfo .tab-continer.row > .tab-center-tab {
  flex: 1 1 0;
  min-width: 0;
  max-width: none;
  padding: 0;
  overflow-x: hidden;
}

.form .leftCard_proInfo
{
    position: fixed;
    top: var(--np-left-top, 128px);
    max-height: calc(100vh - var(--np-left-top, 128px) - 80px);
    overflow-y: auto;
    scrollbar-color: #8C8B99 #eee; /* 设置滚动条的颜色，第一个值为滑块颜色，第二个值为滚动条背景色 */
    scrollbar-width: thin; /* 设置滚动条的宽度 */
}

/* 审批/编辑：左列撑满行高，sticky 才能在长表单滚动时保持可见（flex-start 时左列过矮 sticky 无效） */
.formAdmin .productInfo .tab-continer.row {
  align-items: stretch;
}

.formAdmin .leftCard_proInfo {
  position: sticky !important;
  top: var(--np-admin-left-top, 8px);
  max-height: calc(100vh - var(--np-admin-left-top, 8px) - 80px);
  overflow-y: auto;
  scrollbar-color: #8C8B99 #eee;
  scrollbar-width: thin;
}

.leftCard_proInfo .TipsAndPrivewDilog__icon,
.leftCard_proInfo .TipsAndPrivewDilog__icon-img {
  pointer-events: auto;
}
.b_Card{
      margin-bottom: 16px ;
}
.PublicTabs .assitantCard{  
     border: 1px solid var(--Outline-Surface-Border, #f2f3f5) !important;
     background: var(--Surface, #fff) !important;
    border-radius: 24px !important;
    padding: 24px;
    max-height: 580px;
    box-shadow: 0 0 40px rgba(8, 21, 66, .05);
}
.ItmeUL li{
  padding-bottom: 8px;
}
.ItmeUL li:last-child{
   padding-bottom: 0px;
} 

</style>